import styled from 'styled-components'
import { Box, theme } from '@dasa-health/components-react'

export const Container = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    background-color: #e6ebff;
    margin-top: 3rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin-top: 0;
    }
`

export const Img = styled.img`
    width: 100%;
    max-width: 23.625rem;
    min-width: 8.125rem;
    margin-top: -5.625rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin-top: 0;
        min-width: unset;
        width: 24rem;
        height: 21.25rem;
    }
`

export const Content = styled.div`
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 0 1rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin-top: 0;
        flex-direction: row;
        max-width: calc(100vw - 9.375rem);
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        max-width: 54.5rem;
    }
`

export const Boxes = styled(Box)`
    margin: 0.625rem 0;
`

export const BoxText = styled(Box)`
    &&& {
        width: 100%;
        margin-top: 1.5rem;
    }

    h2:first-child {
        font-weight: 700;
        font-size: 1rem;
        line-height: 2rem;
        color: #161616;
    }

    h2:nth-child(2) {
        font-weight: 400;
        font-size: 0.8125rem;
        line-height: 1.375rem;
        color: #161616;
        margin-top: 0.3rem;
    }
`

export const ButtonsBox = styled(Box)`
    width: 100%;
    display: flex;
    gap: 0.5rem;
    padding: 1.875rem 0;
    align-items: center;

    a {
        flex: 1;
        display: flex;
        justify-content: center;
        text-decoration: none;

        @media screen and (min-width: ${theme.breakpoints[0]}) {
            justify-content: unset;
        }
    }

    button {
        flex: 1;
        font-size: 0.875rem;
        height: 2rem !important;
        max-width: 12.5rem;
        min-height: 3rem;
        margin-top: 1.25rem;
        background-color: #0037ff;
        color: #fefefe;
    }

    button:hover {
        background-color: rgb(0, 47, 219);
        color: #fefefe;
    }
`
